import { buildHead } from "@/lib/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/seller")({
  head: () =>
    buildHead({
      title: "Supplier Central | LohaLink",
      description: "Manage listings, buyer interest, orders and payouts.",
      canonical: "/seller",
      noindex: true,
    }),
  component: lazyRouteComponent(() => import("@/pages/SellerDashboard")),
});
